import styled, { css } from 'styled-components'

export const wrapperCSS = css`
  margin: 0 auto;
  position: relative;
  height: 0;
  width: 100%;
  display: table;
  background: black;
`

export const ThreeByTwoContainer = styled.div`
  ${wrapperCSS}
  padding-bottom: 66.66%;
`
export const Container = styled.div`
  ${wrapperCSS}
  padding-bottom: 56.25%;
`

export const playerCSS = css`
  background-repeat: no-repeat;
  opacity: 0.9;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 0;
  left: 0;
  margin: auto;
  max-width: 100%;
  width: 100%;
  position: absolute;
  right: 0;
  top: 0;
  height: auto;
  background-position: center;
  cursor: pointer;
  transition: all 1s ease-in-out;
`

export const PlayerPlaceholder = styled.div`
  ${playerCSS}
  background-size: cover;
`

export const PlayerPlaceholder3by2 = styled.div`
  ${playerCSS}
  background-size: contain;
`

export const PlayButton = styled.div`
  ${wrapperCSS}
  background: #f00; // youtube red
  border-radius: 50% / 10%;
  height: 48px;
  width: 60px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 1s ease-in-out;
  &::after {
    background: inherit;
    border-radius: 5% / 50%;
    bottom: 9%;
    content: '';
    left: -5%;
    position: absolute;
    z-index: 1;
    right: -5%;
    top: 9%;
  }

  &::before {
    border-style: solid;
    border-width: 10px 0 10px 18px;
    border-color: transparent transparent transparent white;
    content: '';
    font-size: 0.75em;
    display: block;
    z-index: 2;
  }
`

export const IFrame = styled.iframe`
  ${wrapperCSS}
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`
